import React, { FC } from 'react'

const Circles: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="890"
    height="717"
    viewBox="0 0 890 717"
    fill="none"
  >
    <g filter="url(#a)" style={{ mixBlendMode: 'darken' }}>
      <circle cx="206" cy="511" r="133" fill="#E9EEFE" />
    </g>
    <g filter="url(#b)" style={{ mixBlendMode: 'darken' }}>
      <circle cx="212.5" cy="353.5" r="68.5" fill="#E9F3FE" />
    </g>
    <g filter="url(#c)" style={{ mixBlendMode: 'multiply' }}>
      <path
        fill="#D5DEFF"
        fillRule="evenodd"
        d="M666.051 376h45.951l5.564-164.813a94.143 94.143 0 0 1 5.936-.187c51.087 0 92.5 41.414 92.5 92.5s-41.413 92.5-92.5 92.5c-21.709 0-41.671-7.479-57.451-20Z"
        clipRule="evenodd"
      />
    </g>
    <g filter="url(#d)" style={{ mixBlendMode: 'multiply' }}>
      <path
        fill="#E9F3FE"
        fillRule="evenodd"
        d="M693.599 368.633C763.198 356.091 816 295.212 816 222c0-82.29-66.71-149-149-149s-149 66.71-149 149c0 15.478 2.36 30.406 6.74 44.441l6.76-89.941 145-23s12-2.071 18.5 3.5 5 22 5 22l-6.401 189.633Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="a"
        width="412"
        height="412"
        x="0"
        y="305"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1995_41128"
          stdDeviation="36.5"
        />
      </filter>
      <filter
        id="b"
        width="283"
        height="283"
        x="71"
        y="212"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1995_41128"
          stdDeviation="36.5"
        />
      </filter>
      <filter
        id="c"
        width="295.953"
        height="331"
        x="593.051"
        y="138"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1995_41128"
          stdDeviation="36.5"
        />
      </filter>
      <filter
        id="d"
        width="444"
        height="441.633"
        x="445"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1995_41128"
          stdDeviation="36.5"
        />
      </filter>
    </defs>
  </svg>
)

export default Circles
